import { Button, EmptyState } from '@mgrvtechgroup/admin-ds';
import { TriangleAlertIcon } from 'lucide-react';
import { useRouteError } from 'react-router';

/** 라우트 렌더 실패 화면 — 무엇이 안 됐고 다음에 무엇을 하면 되는지 알려 준다(HTR 리뷰: 다음 행동을 알려 주는 오류). */
export function RouteErrorPage() {
  const error = useRouteError();
  const detail = error ? '오류가 계속되면 운영 담당자에게 문의해 주세요.' : null;

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6">
      <h1 className="title-lg text-center">화면을 불러오지 못했습니다</h1>
      <EmptyState
        icon={TriangleAlertIcon}
        title="문제가 발생했습니다"
        description="새로고침해 주세요. 문제가 계속되면 운영 담당자에게 문의해 주세요."
        className="h-auto min-h-0"
      />
      {detail && (
        <code className="caption bg-muted text-muted-foreground rounded-md px-3 py-2 break-all">
          {detail}
        </code>
      )}
      <Button
        onClick={() => {
          window.location.reload();
        }}
      >
        새로고침
      </Button>
    </div>
  );
}
